import { render, staticRenderFns } from "./loadingSpinner.vue?vue&type=template&id=04b2fbd8&scoped=true&"
import script from "./loadingSpinner.vue?vue&type=script&lang=js&"
export * from "./loadingSpinner.vue?vue&type=script&lang=js&"
import style0 from "./loadingSpinner.vue?vue&type=style&index=0&id=04b2fbd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b2fbd8",
  null
  
)

export default component.exports